<template>
  <div class="tech-map-result">
    <div class="container-wrapper">
      <div class="container">
        <h2
          :class="[
            'tech-map-result__title',
            { 'h1' : isMobile }
          ]"
        >
          {{ componentData.title }}
        </h2>
        <BaseTabs
          :tabs="componentData.tabs"
          class="tech-map-result__tabs"
          @tabChange="activeTab = $event"
          @tabChangeArrowPrev="prevArrowTab = $event"
          @tabChangeArrowNext="nextArrowTab = $event"
        />
        <transition name="slide-to-right" mode="out-in">
          <TablePrice
            v-if="table && table.type === 'price'"
            :key="`table-price-${activeTab.value}`"
            class="tech-map-result__table"
            :rows="table.rows"
            :optionalMaterials="componentData.tables.optionalMaterials"
            :materials="componentData.tables.materials_list"
            :warning="table.warning"
            :addWorkPackage="table.addWorkPackage"
            :excludePackageMessage="table.excludePackageMessage"
            @oilChange="setOil"
          />
          <BaseTable
            v-if="table && table.type === 'base'"
            :key="`table-secondary-${activeTab.value}`"
            :expandText="table.viewAllButtonText"
            :rows="table.rows"
            class="tech-map-result__table tech-map-result__table_oil"
            @oilChange="setOil"
          />
        </transition>

        <div :style="{ backgroundColor: activeColor }" class="tech-map-result__request-service-button-container">
          <BaseButton
            @click="requestService"
          >
            {{ componentData.serviceRequestButtonText }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { get } from 'lodash'
  import TablePrice from '@/components/TablePrice'

  export default {
    name: 'TechMapFiltrationResult',
    components: {
      TablePrice
    },
    props: {
      excludePackageMessage: {
        type: String
      },
      arrayOil: {
        type: Array
      },
      componentData: {
        type: Object,
        required: true
      },
      oilsPayload: {
        type: [String, Number],
        default: ''
      },
      currentFilter: Object,
      oilChange: Function
    },
    data () {
      return {
        activeTab: null,

        prevArrowTab: null,
        nextArrowTab: null
      }
    },
    computed: {
      ...mapGetters([
        'getPeriod',
        'getCity',
        'getDealer',
        'isMobile'
      ]),
      table () {
        return this.activeTab && this.componentData.tables[this.activeTab.value]
      },
      activeColor () {
        return this.activeTab && this.activeTab.value === 'required' ? '#F7F7F7' : 'white'
      }
    },
    watch: {
      activeTab: {
        deep: true,
        handler (newVal, oldVal) {
          if (oldVal) this.changeTab(get(newVal, 'text', ''))
        }
      },
      prevArrowTab (v) {
        if (v) this.changeTab('left-arrow', false)
      },
      nextArrowTab (v) {
        if (v) this.changeTab('right-arrow', false)
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.componentData.tables.materials_list.rows.forEach((element, index) => {
          try {
            this.setOil(element['col-1'].list[0].id, index)
          } catch (er) {}
        })
      })
    },
    methods: {
      pushDataToDataLayer (params = {
        events: {
          name: 'formevent',
          componentName: 'book-service',
          componentGroup: 'forms',
          action: 'form-step',
          label: 'service-summary'
        }
      }, pushDataLayer = false, dataLayer = { 'event': 'formevent' }) {
        const lang = get(this, '$store.state.general.lang', '') || get(this, '$store.state.general.locales[0].code', '')
        this.language = lang === 'ua' ? 'uk' : lang

        const event = params.events || {}

        const page = {
          category: 'tools',
          subCategory: 'form',
          sectionlv1: 'forms',
          sectionlv2: 'book-service',
          language: this.language
        }

        const form = {
          name: 'lead-book-service',
          step: 'service-summary',
          conversion: '0'
        }

        const modelId = get(this, '$store.state.model.modelId', '')
        const modelName = get(this, '$store.state.model.modelText', '')

        const product = [{
          category: 'cars',
          subCategory: 'new-cars',
          productInfo: {
            productId: modelId,
            productName: modelName,
            tmeModelId: modelId,
            modelName
          }
        }]

        window.tngaDataLayer = { event, page, form, product }
        if (pushDataLayer) window.dataLayer.push(dataLayer)
      },
      changeTab (label, isPushed = true) {
        this.pushDataToDataLayer({ events: {
          name: 'componentevent',
          componentName: 'book-service',
          componentGroup: 'forms',
          action: 'click-tab',
          label
        } }, isPushed, { 'event': 'componentevent' })
      },
      setOil (value, column) {
        this.$emit('oilChange', value, column)
        this.$store.commit('SET_OIL_ID', value, column)
      },
      requestService () {
        this.$router.push({
          name: 'service-request',
          query: {
            period: this.getPeriod || this.currentFilter.period,
            city: this.getCity || this.currentFilter.city,
            dealer: this.getDealer || this.currentFilter.dealer,
            workpackages: this.$route.query.workpackages,
            oil: this.arrayOil.filter(item => item).join(',')
          },
          params: {
            oil: this.oilsPayload
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .tech-map-result {
    overflow-x: hidden;

    @include mobile {
      min-height: 700px;
    }

    &__title {
      margin: 0 0 44px;
      font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
      text-align: left;

      @include tablet {
        margin: 0 0 42px;
      }

      @include mobile {
        margin: 0 0 19px;
      }
    }

    &__tabs {
      // margin-bottom: 25px;

      @include mobile {
        // margin-bottom: 12px;
      }
    }

    &__table {
      position: relative;

      &_oil {
        .select__field {
          font-size: 15px;
        }
      }
    }

    &__notification {
      margin-top: 40px;
      margin-bottom: 40px;

      @include mobile {
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }

    &__request-service-button-container {
      display: flex;
      justify-content: center;
      padding-bottom: 60px;

      @include mobile {
        padding-bottom: 40px;

        .button {
          max-width: calc(100% - 50px);
        }
      }
    }
  }
</style>
